import { useEffect, useState } from "react";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";

// Suscripción viva a venues/{venueId}/espacios. Los espacios pueden cambiar
// desde otra sesión (otro admin, un seed) mientras la ficha está abierta —
// quien diffee o recalcule el rollup contra una copia one-shot puede excluir
// espacios creados fuera, así que la lectura vive aquí y siempre es snapshot.
// `venueId` null/undefined ⇒ lista vacía sin suscripción (modo local de
// CreateVenue, donde el doc del venue todavía no existe).
export function useEspacios(venueId) {
  const [espacios, setEspacios] = useState([]);
  const [loading, setLoading] = useState(!!venueId);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!venueId) {
      setEspacios([]);
      setLoading(false);
      setError(null);
      return undefined;
    }
    setLoading(true);
    setError(null);
    const unsub = onSnapshot(
      collection(db, "venues", venueId, "espacios"),
      (snap) => {
        setEspacios(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
        setLoading(false);
      },
      (err) => {
        console.error("Error cargando espacios:", err);
        setError(err);
        setLoading(false);
      }
    );
    return unsub;
  }, [venueId]);

  return { espacios, loading, error };
}
